export default __webpack_public_path__ + "static/media/bkg--home-1.0bffff9f.jpg";